import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { RedeemRulesSearchState } from '../models/redeem-rules.model';
import * as selectors from '../selectors/search.selectors';

@Injectable({ providedIn: 'root' })
export class RedeemRulesSearchFacadeService extends FacadeService {
  constructor(public override store: Store<RedeemRulesSearchState>) {
    super(store);
  }

  // OBSERVABLES
  schemas$ = this.storeSelect(selectors.getSchemas);
  selectedSchema$ = this.storeSelect(selectors.getSelectedSchema);
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  lastSearchResponse$ = this.storeSelect(selectors.getLastSearchResponse);

  // OBSERVABLE VALUES
  get schemas() {
    return this.storeSnapshot(this.schemas$);
  }

  get selectedSchema() {
    return this.storeSnapshot(this.selectedSchema$);
  }

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get lastSearchResponse() {
    return this.storeSnapshot(this.lastSearchResponse$);
  }
}
